import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderCoverageTaxDataSchema } from './ServicesProviderCoverageTaxData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderCoverageTax extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderCoverageTaxDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderCoverageTax.validation', `ServicesProviderCoverageTax data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.COVERAGE_TAX,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.COVERAGE_TAX, ServicesProviderCoverageTax);

export { ServicesProviderCoverageTax };
//# sourceMappingURL=ServicesProviderCoverageTax.js.map
